import LevelZeroIcon from "@assets/icons/sourcing-theme-level-zero.svg";
import LevelOneIcon from "@assets/icons/sourcing-theme-level-one.svg";
import LevelThreeIcon from "@assets/icons/sourcing-theme-level-three.svg";
import LevelTwoIcon from "@assets/icons/sourcing-theme-level-two.svg";

import type { IThemeTag } from "@interfaces/tag.interface";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IThemeTag;
  isLevelOneBased?: boolean;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionTheme = ({ item, isLevelOneBased, ...rest }: Props) => {
  const themeLevel = isLevelOneBased ? item.level - 1 : item.level;

  let Icon;
  switch (themeLevel) {
    case 0:
      Icon = LevelZeroIcon;
      break;
    case 1:
      Icon = LevelOneIcon;
      break;
    case 2:
      Icon = LevelTwoIcon;
      break;
    case 3:
      Icon = LevelThreeIcon;
      break;
    default:
      Icon = LevelThreeIcon;
      break;
  }

  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      {Icon && <Icon width={20} height={20} className="flex-shrink-0" />}
      <TagLabel>{item.title}</TagLabel>
    </div>
  );
};
